import { render } from "./Osteo.vue?vue&type=template&id=3b84561f&scoped=true"
import script from "./Osteo.vue?vue&type=script&lang=js"
export * from "./Osteo.vue?vue&type=script&lang=js"

import "./Osteo.vue?vue&type=style&index=0&id=3b84561f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b84561f"]])

export default __exports__